import { render, staticRenderFns } from "./AssessmentScores.vue?vue&type=template&id=64bc0e3a&"
import script from "./AssessmentScores.vue?vue&type=script&lang=js&"
export * from "./AssessmentScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64bc0e3a')) {
      api.createRecord('64bc0e3a', component.options)
    } else {
      api.reload('64bc0e3a', component.options)
    }
    module.hot.accept("./AssessmentScores.vue?vue&type=template&id=64bc0e3a&", function () {
      api.rerender('64bc0e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/AssessmentScores.vue"
export default component.exports